import './SortDropdown.css';
import React, { useRef } from 'react';
import { canUseDOM, get, getDictionaryItem } from '../../../../../utils';
import IconChevronDown from '../../../../../resources/icons/IconChevronDown.svg';
import IconChevronDownYellow from '../../../../../resources/icons/IconChevronDownYellow.svg';
import { removeQueryString, default as addQueryString, splitter, addQuerySorting, removeQuerySortingString } from '../../../../Listing/index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../../../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../../utils/tealium';

// let facetFilters: any = convertQueryParamsToFacets(queryParams);

const SortDropdown = _ref => {
  let {
    fields,
    hideLabel,
    hideAmount,
    dictionary,
    showLabel,
    selectAllLabel,
    resultsLabel,
    clearAllLabel,
    buttonYellow,
    openWithWrapper,
    keepOpenOnChange,
    widgetAnalytics,
    facets,
    nbHits,
    setFilter,
    facetsName,
    indexDropDown,
    firstQuery,
    firstFilter,
    wrapperToggle,
    defaultFacets,
    hideDesktopShowButton,
    hideShowButton,
    setSubpanelLabel,
    onChangeCallback,
    onToggleCallback,
    clearAlllFilters,
    analytics,
    getFilterValue,
    resetAllFiltersCallback,
    searchIndex,
    columnsClass = 'col-md-12',
    isNestedFilters = false
  } = _ref;
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const [isOpen, setisOpen] = React.useState(false);
  const filterName = get(fields, 'name');
  const label = get(fields, 'title.jss.value');
  const tagsToDisplay = get(fields, 'tagsToDisplay.values');
  const showSelectAllOption = get(fields, 'showSelectAllOption.jss.value');
  const selectedTagsToDisplay = get(fields, 'preselectedTags.values') || [];
  const [filteredOptions, setfilteredOptions] = React.useState([]);
  const [filteredLabel, setfilteredLabel] = React.useState('');
  const checkboxes = /*#__PURE__*/React.createRef();
  let history = useHistory();
  const type = 'radio';
  const filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  const rootRef = useRef();
  const mapDictionary = {
    distanceDWC: 'search.distanceFromAlMaktoumIntAirport',
    distanceDXB: 'search.distanceFromDubaiInternationalAirport'
  };
  const createFacets = (tagsToDisplay, facets) => {
    let filteredOptions = [];
    if (facets) {
      filteredOptions = facets.map(item => ({
        key: item.fieldName.value,
        label: getDictionaryItem(dictionary, mapDictionary[item.fieldName.value]),
        name: item.fieldName.value
      }));
    }
    return filteredOptions;
  };
  const toggleFilter = () => {
    setisOpen(!isOpen);
    wrapperToggle(isOpen);
  };
  const clearFilter = e => {
    setisOpen(false);
    setfilteredLabel('');
    setFilter();
    wrapperToggle(true, false);
    removeQuerySortingString(facetsName, history, searchIndex);
    const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      checkboxesArray[i].checked = false;
    }
    getFilterValue && getFilterValue(fields.name, facetsName, null);
    if (e) {
      e.stopPropagation();
    }
  };
  const setChecked = checkboxes => {
    let setfilteredLabelArray = [];
    const queries = queryParams[`${filterType}`];
    const checkboxesArray = checkboxes.querySelectorAll('.input-choice');
    queries && queries.split(splitter).map(item => {
      for (let i = 0; i <= checkboxesArray.length - 1; i++) {
        // checkboxesArray[i].checked = false;
        if (checkboxesArray[i].value === item.split('+').join(' ')) {
          checkboxesArray[i].checked = true;
          if (setfilteredLabelArray.length === 0) {
            setfilteredLabelArray.push(checkboxesArray[i].value);
          } else {
            setfilteredLabelArray.push(', ' + checkboxesArray[i].value);
          }
        }
      }
    });
    if (setfilteredLabelArray.length !== 0) {
      setfilteredLabel(setfilteredLabelArray);
    } else {
      setfilteredLabel('');
    }
  };
  React.useEffect(() => {
    if (firstFilter) {
      setfilteredOptions(createFacets(tagsToDisplay, defaultFacets));
    }
    if (filterType === firstQuery) {} else {
      setfilteredOptions(createFacets(tagsToDisplay, facets));
    }
  }, [facets, defaultFacets]);
  React.useEffect(() => {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
        facetsName.forEach(f => addQueryString(f, preselectedTags.join(','), history));
        setFilter();
        resetAllFiltersCallback();
      } else {
        clearFilter();
      }
    }
  }, [clearAlllFilters]);
  React.useEffect(() => {
    setChecked(checkboxes.current);
  }, [filteredOptions, facets]);
  const submitFilters = (e, facetsName) => {
    createFacets(tagsToDisplay, defaultFacets);
    const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
    const selected = {};
    filteredOptions.forEach(_ref2 => {
      let {
        key,
        label,
        name
      } = _ref2;
      selected[key] = false;
    });
    let selectedCheckboxes = [];
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selected[checkboxesArray[i].value] = true;
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    setFilter(true, undefined, selectedCheckboxes);
    // selectedCheckboxes = selectedCheckboxes.toString();
    !!selectedCheckboxes.length && setfilteredLabel(selectedCheckboxes.map(v => getDictionaryItem(dictionary, mapDictionary[v])));
    if (!keepOpenOnChange) {
      setisOpen(false);
    }
    getFilterValue && getFilterValue(fields.name, facetsName, selected);
    addQuerySorting(facetsName, selected, history, searchIndex);
    e.stopPropagation();
  };
  const closeDropdwn = event => {
    if (event.target.closest) {
      if (event.target.closest('.filter__field') !== rootRef.current && !event.target.closest('.filter__header')) {
        setisOpen(false);
        wrapperToggle(true);
      } else if (event.target.closest('.filter__header-links')) {
        setisOpen(false);
        wrapperToggle(true);
      }
    } else {
      setisOpen(false);
      wrapperToggle(true);
    }
  };
  React.useEffect(() => {}, [facets]);
  React.useEffect(() => {
    const queries = queryParams[`${filterType}`];
    if (isNestedFilters) {
      if (selectedTagsToDisplay.length) {
        const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
        facetsName.forEach(f => addQueryString(f, preselectedTags.join(','), history));
        setFilter(true);
      }
    } else {
      if (!queries && selectedTagsToDisplay.length) {
        const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
        facetsName.forEach(f => addQueryString(f, preselectedTags.join(','), history));
        setFilter(true);
      }
    }
    document.body.addEventListener('click', closeDropdwn);
    return () => {
      facetsName.forEach(f => removeQueryString(f, history));
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field filter__field-dropdown sort-dropdown",
    ref: rootRef
  }, /*#__PURE__*/React.createElement("div", {
    className: `filter-panel eloqua ${isOpen ? 'filter-panel--open' : ''}`
  }, hideLabel ? null : /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: `filter-panel__box ${isOpen ? 'filter-panel__box--openedDrop' : ''}`,
    onKeyPress: event => {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        event.target.click();
      }
    },
    onClick: () => {
      onToggleCallback && onToggleCallback();
      if (openWithWrapper) {
        toggleFilter();
      } else {
        setisOpen(!isOpen);
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, filteredLabel ? filteredLabel : label), /*#__PURE__*/React.createElement("img", {
    className: "icon",
    src: buttonYellow ? IconChevronDownYellow : IconChevronDown,
    alt: "smth"
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, clearAllLabel ? /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, showSelectAllOption ? /*#__PURE__*/React.createElement("span", {
    className: "body-medium fp__inner-clear cursor-pointer",
    onClick: e => {
      const inputs = checkboxes.current.querySelectorAll('.input-choice');
      inputs.forEach(input => {
        input.checked = true;
      });
      wrapperToggle(true);
      submitFilters(e, facetsName);
    }
  }, selectAllLabel ? selectAllLabel : '') : /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("button", {
    className: "body-medium fp__inner-clear cursor-pointer btn--reset",
    onClick: e => {
      clearFilter(e);
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
    },
    onKeyPress: e => {
      if (e.which === 13) {
        e.preventDefault();
        clearFilter(e);
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
      }
    }
  }, clearAllLabel)) : null, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes
  }, filteredOptions.map((item, index) => {
    const {
      key,
      label,
      name
    } = item;
    return /*#__PURE__*/React.createElement("label", {
      className: "checkbox-aligned fp__inner-label",
      htmlFor: key.replace(/\s/g, '_'),
      key: index
    }, /*#__PURE__*/React.createElement("input", {
      className: `input-choice ${type === 'radio' ? 'fp__radio' : 'fp__checkbox'}`,
      type: type
      //defaultChecked={setChecked(key, filterType)}
      ,

      name: `dropdown=${indexDropDown}`,
      value: key,
      onChange: e => {
        onChangeCallback && onChangeCallback();
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${name ? name : key}`);
        if (hideDesktopShowButton) {
          if (canUseDOM && window.innerWidth >= 768) {
            submitFilters(e, facetsName);
            wrapperToggle(true);
          }
        } else if (hideShowButton) {
          submitFilters(e, facetsName);
          wrapperToggle(true);
        }
      },
      id: key.replace(/\s/g, '_')
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  }))), !hideDesktopShowButton || !hideShowButton ? /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    onClick: e => {
      wrapperToggle(true);
      submitFilters(e, facetsName);
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterShowResultsAnalytics, analytics.params));
    }
  }, showLabel, " ", resultsLabel)) : null))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    columnsClass
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${columnsClass}`
  }, children);
};

// export default SortDropdown;
export default SortDropdown;
const commonStyles = "cg6fcat";